import { ReplicaType } from "types";
import Version2 from "./v2";
import Version3 from "./v3";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "advanced-potion-making-edition-II-clean-copy",
  name: `Advanced Potion-Making\nEdition II\nClean Copy`,
  nameFormatted: {
    primary: "Advanced Potion-Making",
    secondary: "Edition II",
    tertiary: "Clean Copy",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  sort: {
    preferredIndex: 2,
  },

  category: replicaCategories.harryPotter,

  versions: [Version3, Version2],
};

export default data;
